
<div class="logo">
    @if (brandLogoSvg) {
         <mat-icon class="logo-icon-svg" svgIcon="login-logo__brand" aria-hidden="true"></mat-icon>
    }
    @else {
        <img src="assets/{{ brand }}/images/logos/brand-square.png" alt="" />
    }
</div>